<div class="process-charts-wrapper fw fh">
    <router-outlet></router-outlet>
</div>